/* eslint-disable */
import { base, baseXlsx } from '@/utils/api'

const ENDPOINT = '/clinics'

export default {
  getClinics(rootClinicId, query) {
    return base.get(`${ENDPOINT}/all/${rootClinicId}`, {
      params: {
        query
      }
    })
  },
  createUnity(data) {
    return base.post(`${ENDPOINT}/unity`, data)
  },
  updateUnity(id, data) {
    return base.patch(`${ENDPOINT}/unity/${id}`, data)
  },
  saveClinicBrand(clinicId, data) {
    return baseUpload.post(`clinic/${clinicId}/saveBrand`, data)
  },
  deleteClinic(id, confirm = false) {
    // confirm=true: usuário confirmou a exclusão de unidade COM dados
    // operacionais depois do 409 do backend (impl-07 S1).
    return base.delete(`${ENDPOINT}/unity/${id}`, {
      params: confirm ? { confirm: true } : {}
    })
  },

  // chat-message/settings
  getPatientChatSetting() {
    return base.get(`chat-message/settings`)
  },
  savePatientChatSetting(data) {
    return base.post(`chat-message/settings`, data)
  },
  updatePatientChatSetting(id, data) {
    return base.put(`chat-message/settings/${id}`, data)
  },
  deletePatientChatSetting(id) {
    return base.delete(`chat-message/settings/${id}`)
  }
}
